module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-remark-images@7.16.0_gatsby-plugin-sharp@5.16.0_gatsby@5.16.1_babel-eslint@10.1._3cde101384be3169e01dbb83ecf83307/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":840,"wrapperStyle":"margin-left: 0","linkImagesToOriginal":true,"showCaptions":false,"markdownCaptions":false,"backgroundColor":"white","quality":50,"withWebp":false,"withAvif":false,"loading":"lazy","decoding":"async","disableBgImageOnAlpha":false,"disableBgImage":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@19.2.7_react@19.2.7__react@1_ed3c081268f73ce41e65c9b57f8ac5a5/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
